import { EPlatformFeature } from '@enums/campaign.enum';
import { TranslateService } from '@ngx-translate/core';
import { ICtaAnalyticsData } from '../../cta-analytics-table.interface';
import { IDeliverableCard } from '../cta-analytics-details-deliverable-card/cta-analytics-details-deliverable-card.interface';
import { BaseAnalyticsFormatter } from './base-analytics-formatter';

export class XPostAnalyticsFormatter extends BaseAnalyticsFormatter {
  constructor(execution: ICtaAnalyticsData, translate: TranslateService) {
    super(EPlatformFeature.xPost, execution, translate);
  }

  public generateDeliverableCardData(): IDeliverableCard[] {
    const message = this.processMessage();
    const hashtag = this.processHashTag();
    const mention = this.processMention();
    const content = this.processContent();
    const talkingPoints = this.processTalkingPoints();
    const talkingPointAis = this.processTalkingPointAis();
    const textTracking = this.processTextTracking();
    const audioTracking = this.processAudioTracking();
    const visual = this.processVisual();
    const productPlacement = this.processProductPlacements();
    const custom = this.processCustom();

    return [
      ...(message ?? []),
      ...(hashtag ?? []),
      ...(mention ?? []),
      ...(content ?? []),
      ...(custom ?? []),
      ...(talkingPoints ?? []),
      ...(talkingPointAis ?? []),
      ...(textTracking ?? []),
      ...(audioTracking ?? []),
      ...(visual ?? []),
      ...(productPlacement ?? []),
    ];
  }
}
